import { WarningBarProps } from './types';
import { ReactComponent as WarningIcon } from '../../assets/icons/ContractWarningIcon.svg';
import { ReactComponent as InfoIcon } from '../../assets/icons/ContractInfoIcon.svg';
import { WarningAlertStyled } from './styles';

const WarningBar = (props: WarningBarProps): JSX.Element => {
  const { message, variant = 'warning' } = props;
  const Icon = variant === 'info' ? InfoIcon : WarningIcon;

  return (
    <WarningAlertStyled severity={variant} icon={false} barVariant={variant}>
      <Icon className="error-warning-icon" />
      <div>{message}</div>
    </WarningAlertStyled>
  );
};

WarningBar.defaultProps = {
  message: '',
  variant: 'warning',
};

export default WarningBar;
